exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".padding {\r\n    margin-bottom: 5%;\r\n}\r\n.color:hover {\r\n    color: #ffffff;\r\n    background-color: #007eed;\r\n}\r\n\r\n.color:active {\r\n    color: #ffffff;\r\n    background-color: #0084b4;\r\n}\r\n\r\n.error {\r\n    border: 1px solid red;\r\n}\r\n\r\n.statusEnable {\r\n    color: #ffffff;\r\n    background-color: #18bc9c;\r\n    border-color: #18bc9c;\r\n}\r\n\r\n.statusDisable {\r\n    color: #ffffff;\r\n    background-color: #e74c3c;\r\n    border-color: #e74c3c;\r\n}\r\n.statusEnable:focus {\r\n    color: white;\r\n}\r\n.statusDisable:focus {\r\n    color: white;\r\n}\r\n.statusEnable:hover,.statusEnable:active {\r\n    color: #ffffff;\r\n    background-color: #128f76;\r\n    border-color: #11866f;\r\n}\r\n\r\n.statusDisable:hover,.statusDisable:active {\r\n    color: #ffffff;\r\n    background-color: #d62c1a;\r\n    border-color: #cd2a19;\r\n}\r\n\r\n.modal-dialog {\r\n    position: center;\r\n    margin-top: 10%;\r\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./app/main/sentienceDeviceManager/sentience-device-manager.component.css
 ** module id = 951
 ** module chunks = 2
 **/